import(/* webpackMode: "eager" */ "/home/u902218437/domains/allaboutcampus.com/hbuilds/source/eduportal/src/app/sign-up/page.tsx");
